// components/PermissionRoutes/PermissionRoutes.jsx
import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { hasPermission } from "../../pages/Login/authUtils";
import Error404 from "../../pages/404Error/404Error";

const getLoggedInRole = () => {
  try {
    const userDetails = JSON.parse(localStorage.getItem("userDetails") || "{}");

    const rawRole =
      userDetails?.role?.roleName ||
      userDetails?.role?.name ||
      userDetails?.role?.title ||
      userDetails?.role ||
      "";

    return String(rawRole).trim().toLowerCase();
  } catch (error) {
    console.error("Unable to read logged-in user role:", error);
    return "";
  }
};

const PermissionRoute = ({ children, permission, isPublic = false }) => {
  const isAuthenticated = localStorage.getItem("authenticated") === "true";

  const location = useLocation();
  const path = location.pathname;

  // Public routes such as login and register
  if (isPublic) {
    return isAuthenticated ? <Navigate to="/" replace /> : children;
  }

  // Require login
  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Admin and Super Admin can access every protected route
  const loggedInRole = getLoggedInRole();

  const hasFullAccess = ["admin", "super admin", "superadmin"].includes(
    loggedInRole,
  );

  if (hasFullAccess) {
    return children;
  }

  // Dynamic permission translation
  let requiredPermission = permission;

  const getModelFromPath = () => {
    const parts = path.split("/").filter(Boolean);

    /*
     * Examples:
     *
     * /table/uauc       -> uauc
     * /edit/uauc/:id    -> uauc
     * /create/uauc      -> uauc
     */
    return parts[1] || "";
  };

  if (permission && permission.startsWith("table:")) {
    const action = permission.split(":")[1];
    const model = getModelFromPath().toLowerCase();

    if (model) {
      const actionSuffix =
        action === "edit" || action === "create" ? "write" : "view";

      requiredPermission = `${model}.${actionSuffix}`;
    }
  }

  // Normal users must have the required permission
  if (requiredPermission && !hasPermission(requiredPermission)) {
    return <Error404 />;
  }

  return children;
};

export default PermissionRoute;
